// @flow
import { createContext } from 'react';

export const MonthlyInputsMetaDataContext = createContext(null);
